module.exports = __webpack_public_path__ + "static/media/header-img2.343aabc1.png";